export default "__VITE_ASSET__hHG2GzGS__"